import { Controller } from "@hotwired/stimulus";
import { REPORT_TABLE_ID } from "constants/print_mapping_constants"
import { getPrintMappingReports } from "shared/print_mapping/reports";
import { sendFailureNotification } from "shared/toast_notifications";

// Connects to table--print-mapping-report-table
export default class extends Controller {

    initialize() {
        // Defer so argus--table connects first
        Promise.resolve().then(() => {
            this.#setupAndLoad();
        });
    }

    /**
     * Get the argus--table controller for the print mapping export table
     */
    _getArgusTable() {
        const el = document.getElementById(REPORT_TABLE_ID);
        if (!el || !window.Stimulus) return null;
        return window.Stimulus.getControllerForElementAndIdentifier(el, 'argus--table');
    }

    #setupAndLoad() {
        const argusTable = this._getArgusTable();
        if (!argusTable) {
            console.warn('table--print-mapping-report-table: argus--table controller not found');
            return;
        }

        // Set up columns programmatically
        argusTable._columns = [
            { field: 'name', title: 'Name', sortable: true, visible: true },
            { field: 'created_by.name', title: 'Created by', sortable: true, visible: true },
            { field: 'created_at', title: 'Created at', sortable: true, visible: true, formatter: 'dateFormatter' },
            { field: 'state', title: 'State', sortable: true, visible: true },
            { field: 'status', title: 'Status', sortable: false, visible: true },
            { field: 'id', title: 'Report', sortable: false, visible: true, formatter: 'reportColumnFormatter' }
        ];

        // Rebuild column toggler
        const ColumnTogglerClass = argusTable.columnToggler.constructor;
        argusTable.columnToggler = new ColumnTogglerClass(
            argusTable._columns, () => argusTable._render()
        );

        // Load data
        this.loadReports();
    }

    /**
     * Fetch print mapping reports and load into argus--table
     */
    loadReports() {
        const argusTable = this._getArgusTable();
        if (!argusTable) return;

        argusTable.showLoading();

        getPrintMappingReports().then((results) => {
            const formatted = formatTableData(results);
            argusTable.loadData(formatted);
        }).catch((error) => {
            console.error('Error loading print mapping reports:', error);
            sendFailureNotification(error?.message || 'Failed to load print mapping reports');
        }).finally(() => {
            argusTable.hideLoading();
        });
    }
}
